import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    analyze: '',
  },
  mutations: {
    // 存储分词内容
    details(state, analyze) {
      state.analyze = analyze
    },
  },
  actions: {}
});